import { render, staticRenderFns } from "./index.vue?vue&type=template&id=373ea4cf&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=373ea4cf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373ea4cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('373ea4cf')) {
      api.createRecord('373ea4cf', component.options)
    } else {
      api.reload('373ea4cf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=373ea4cf&scoped=true", function () {
      api.rerender('373ea4cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ActivityEnd/index.vue"
export default component.exports